module.exports = __webpack_public_path__ + "static/media/carnet-back.2e9ad3d2.png";